/* global app */
import React, { useEffect, useState } from 'react';
import '../assets/styles/main.scss';
import { Provider } from './Context';
import Sdk from '../sdk/Sdk';
import { UiElement, Colors } from '../types/player';
import { PlayerEvents } from '../sdk/PlayerEvents';
import { Events } from '../types/player'
export default function PlayerInstance(props: { sdk: Sdk }) {
  const { sdk } = props;

  const [destroy, setDestroy] = useState(false);

  const injectCSS = () => {
    let cssContent = sdk.options().getCss();
    if (!cssContent) return;
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(cssContent));
    document.head.appendChild(style);
  };

  const injectJS = () => {
    let jsContent = sdk.options().getJs();
    if (!jsContent) return;
    const script = document.createElement('script');
    script.textContent = jsContent;
    document.body.appendChild(script);
  };

  const setColorStyle = () => {
    let colors = sdk.options().getColors();
    if (!colors) return;
    const prefix = sdk.getClassNamePrefix();

    const root = document.querySelector(`.${prefix}-player`) as HTMLElement;
    if (!root) return;

    colors.forEach((color) => {
      const colorValue = color.value as string;
      if (!colorValue) return;
      if (!color.elements || color.elements.length === 0) {
        root.style.setProperty('--player-prefix-icon', prefix + '-icon');
        root.style.setProperty('--player-color-primary', colorValue);
        root.style.setProperty(
          `--player-color-cta-text`,
          getContratColor(colorValue),
        );
        root.style.setProperty(
          `--player-color-tooltip-text`,
          getContratColor(colorValue),
        );
      } else {
        color.elements.forEach((element: UiElement) => {
          root.style.setProperty(`--player-color-${element}`, colorValue);
          if ([UiElement.TOOLTIP_BACKGROUND].includes(element)) {
            root.style.setProperty(
              `--player-color-${element}-text`,
              getContratColor(colorValue),
            );
          }
        });
      }
    });
  };

  const getContratColor = (hexcolor: string) => {
    hexcolor = hexcolor.replace('#', '');

    const r = parseInt(hexcolor.substring(0, 2), 16);
    const g = parseInt(hexcolor.substring(2, 4), 16);
    const b = parseInt(hexcolor.substring(4, 6), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 128 ? '#FFFFFF' : '#000000';
  };

  useEffect(() => {
    setColorStyle();
    injectJS();
    injectCSS();
    let listener = sdk.on(Events.DESTROY, () => {
      setDestroy(true);
    });
    return () => {
      listener(); 
    }
  }, []);

  if(destroy) 
    return null;

  return <Provider sdk={sdk} />;
}
